import { updateSelectedDate } from 'owa-agenda-events-list';
import type { OwaDate } from 'owa-datetime';
import { selectDayGridDate } from 'owa-day-grid';
import { CalendarViewType } from '../schema';
import { assertNever } from 'owa-assert';

/**
 * Notifies subcomponents of changes in the selected date
 * @param scenarioId
 * @param selectedView
 * @param date
 */
export function updateSelectedViewDate(
    scenarioId: string,
    selectedView: CalendarViewType,
    date: OwaDate
) {
    switch (selectedView) {
        case CalendarViewType.Agenda:
            updateSelectedDate(date, scenarioId);
            break;
        case CalendarViewType.Day:
            selectDayGridDate(scenarioId, date);
            break;
        // TODO: VSO #112389 [Day Grid cleanup]
        // We rely on the `selectedDate` effect hook in `useCalendarViewState` to handle week/workweek navigation
        // and therefore do nothing here as it would otherwise cause the grid to navigate incorrectly
        // Longer-term, we should get `owa-day-grid-core` to handle date selections better for week/workweek view so we can safely call `selectDayGridDate` hook in all grid cases
        case CalendarViewType.Week:
        case CalendarViewType.WorkWeek:
        case CalendarViewType.Month:
            break;
        default:
            assertNever(selectedView);
    }
}
